<template>
  <div class="page-create">
    <FrameHeader/>
    <div v-if="on_step == 'init'" class="boxed page-create-main">

      <div class="py-3 pb-5">
        <router-link :to="{name: 'home'}">
          <i class="fas fa-arrow-left"></i>
          <span>
            {{lg('',{
              en: 'Back',
              zh: '返回',
            })}}
          </span>
        </router-link>
      </div>

      <div class="tac">
        <h1>
          {{lg('',{
            en: 'Create Collectible',
            zh: '铸造您的NFT',
          })}}
        </h1>
        <h5 class="pt-4 mx-auto b" style="max-width: 750px; line-height: 2em;">
          {{lg('',{
            en: 'Choose “single” if you want your collectible to be one of a kind or “Multiple” if you want to sell one collectible multiple times.',
            zh: '您如果想让您的NFT独一无二，请选择“单个”；您如果想将一件NFT多次售出，请选择“多个”。',
          })}}
        </h5>
      </div>

      <!-- card box -->
      <div class="py-5 mx-auto d-flex flex-wrap justify-content-around" style="max-width: 800px;">

        <div 
          @click="openForm({
            single_or_multi: 'single',
          })"
          class="sp-card-create">
          <div class="pic-box d-flex justify-content-center">
            <img class="mx-2" src="/static/pic/page_create/icon-create-item.png" alt="">
          </div>
          <div class="tac">
            <div class="b">
              {{lg('',{
                en: 'Single',
                zh: '单个',
              })}}
            </div>
            <div class="t-gray">
              BEP-721
            </div>
          </div>
        </div>

        <div 
          @click="openForm({
            single_or_multi: 'multi',
          })"
          class="sp-card-create"
          >
          <div class="pic-box d-flex justify-content-center">
            <img class="mx-2" src="/static/pic/page_create/icon-create-item.png" alt="">
            <img class="mx-2" src="/static/pic/page_create/icon-create-item.png" alt="">
          </div>
          <div class="tac">
            <div class="b">
              {{lg('',{
                en: 'Multiple',
                zh: '多个',
              })}}
            </div>
            <div class="t-gray">
              BEP-1155
            </div>
          </div>
        </div>
      </div>

      <div class="tac">
        <h5 class="b">
          {{lg('',{
            en: 'We do not own your private keys and cannot access your funds without your confirmation.',
            zh: '我们不掌握您的相关私钥，且没有您的签名确认也无法动用您的资产。',
          })}}
        </h5>
      </div>
    </div>

    <div class="boxed">
      <creatFrom 
        v-if="on_step == 'form'"
        :cfg_type="form_cfg_single_or_multi"
      />
    </div>

    <FrameFooter/>
  </div>
</template>

<script>
import creatFrom from './create_form.vue'

export default {
  name: 'create',
  components: {
    creatFrom,
  },
  props: [],
  data() {
    return {
      // 01 init 02 form 
      on_step: 'init',

      form_cfg_single_or_multi: 'multi',
    }
  },
  computed: {},
  watch: {},
  methods: {
    
    openForm(obj){
      let v = this
      v.on_step = 'form'
      v.form_cfg_single_or_multi = obj.single_or_multi
    },
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-create{
    background-color: #fff;

    .page-create-main{
      // background: url('/static/img/css_img/bg_comingsoon.png') center 55px no-repeat;
      @media(max-width: 788px){
        background-size: contain;
        background-position: center 55px;
      }

      .sp-card-create{
        width: 330px;
        border-radius: 50px;
        box-shadow: 10px 15px 25px 0 rgba(0,0,0,0.2);
        padding: 40px;
        border: 1px solid transparent;
        cursor: pointer;
        margin-bottom: 30px;
        transition: all .2s;

        &:hover{
          border-color: $c;
        }

        .pic-box{
          padding-top: 80px;
          padding-bottom: 60px;
          box-sizing: border-box;
          height: 260px;
          img{
            width: 50%;
          }
        }
      }
    }
  }
</style>